import styled from 'styled-components';

export const contentName = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export const TextName = styled.p`
  font-size: 1.3rem;
  text-align: center;
  font-weight: bold;
`;

export const TextHeader = styled.p`
  font-size: 0.9rem;
`;

export const textTerminal = {
  border: 'none',
  marginTop: '1rem',
};

export const TextNormal = styled.p`
  font-size: 1rem;
`;

export const TextBold = styled.p`
  font-weight: bold;
`;

export const styleSeparator = {
  textAlign: 'center',
  fontSize: '1rem',
};

export const styleCardContent = { paddingTop: '.2rem', paddingBottom: '.2rem' };

export const OptionsButton = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0;
  cursor: pointer;
`;
export default {};
